import { makeAutoObservable } from 'mobx';

class SettingsState {
  _mouse = true;
  _playerLog = __DEV__;
  _fetchLog = __DEV__;
  _devServer = __DEV__;

  constructor() {
    makeAutoObservable(this);
  }

  get mouse() {
    return this._mouse;
  }
  set mouse(value: boolean) {
    this._mouse = value;
  }

  get playerLog() {
    return this._playerLog;
  }
  set playerLog(value: boolean) {
    this._playerLog = value;
  }

  get fetchLog() {
    return this._fetchLog;
  }
  set fetchLog(value: boolean) {
    this._fetchLog = value;
  }

  get devServer() {
    return this._devServer;
  }
  set devServer(value: boolean) {
    this._devServer = value;
  }
}

export default new SettingsState();
